import { render, staticRenderFns } from "./ChallengeDates.vue?vue&type=template&id=3a71a121&scoped=true&lang=pug&"
import script from "./ChallengeDates.vue?vue&type=script&lang=js&"
export * from "./ChallengeDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71a121",
  null
  
)

export default component.exports